import { render, staticRenderFns } from "./svg-icon.vue?vue&type=template&id=7edb3882&scoped=true"
import script from "./svg-icon.vue?vue&type=script&lang=js"
export * from "./svg-icon.vue?vue&type=script&lang=js"
import style0 from "./svg-icon.vue?vue&type=style&index=0&id=7edb3882&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edb3882",
  null
  
)

export default component.exports